export interface IPage<T> {
    items: T[];
    total: number;
    page: number;
    size: number;
    pages: number;
}

export interface IFilter {
    q?: string;
    sort_by?: string;
    order?: "asc" | "desc";
}

export const buildQuery = (filter: IFilter = {}) => {
    // q is raw user input from a search box at every call site. Interpolated unencoded,
    // a typed "&" ends the parameter and the rest of the term becomes a separate query
    // parameter the server ignores -- so searching "Bed Bath & Beyond" silently
    // searches "Bed Bath " and returns the wrong stores rather than failing.
    const q = filter.q ? `q=${encodeURIComponent(filter.q)}` : undefined;
    const sort_by = filter.sort_by ? `sort_by=${filter.sort_by}` : "";
    const order = filter.order ? `order=${filter.order}` : "";
    return [q, sort_by, order].filter(Boolean).join("&");
};
